(function() {
  function initTiles() {
    document.querySelectorAll('.cl-tile__swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var wrapper = swatch.closest('[data-tile]');
        if (!wrapper) return;
        var tileId = wrapper.dataset.tile;
        var tile = document.getElementById(tileId);
        if (!tile) return;

        // Imágenes
        var allTileImgs = tile.querySelectorAll('img.is-complete');
        var mainImg = allTileImgs[0];
        var hoverImg = allTileImgs.length > 1 ? allTileImgs[1] : null;

        if (mainImg && swatch.dataset.image) {
          mainImg.removeAttribute('srcset');
          mainImg.style.transition = 'opacity 0.15s';
          mainImg.style.opacity = '0';
          setTimeout(function() {
            mainImg.src = swatch.dataset.image;
            mainImg.style.opacity = '1';
          }, 50);
        }

        if (hoverImg) {
          hoverImg.removeAttribute('srcset');
          hoverImg.src = (swatch.dataset.imageHover && swatch.dataset.imageHover.trim() !== '') ? swatch.dataset.imageHover : swatch.dataset.image;
        }

        // Actualizar enlaces
        tile.querySelectorAll('a[href]').forEach(function(a) {
          if (!a.closest('[data-tile]')) return;
          a.href = swatch.dataset.url;
        });

        // Actualizar título
        var titleEl = tile.querySelector('p[aria-hidden="true"]');
        if (titleEl && swatch.dataset.title) titleEl.textContent = swatch.dataset.title;

        // Marcar swatch activo
        wrapper.querySelectorAll('.cl-tile__swatch').forEach(function(s) {
          s.style.borderColor = 'transparent';
        });
        swatch.style.borderColor = '#7F7B77';
        swatch.style.borderWidth = '1px';
      });
    });

    // Flechas
    document.querySelectorAll('[data-tile]').forEach(function(wrapper) {
      var prevBtn = wrapper.querySelector('.cl-tile__arrow--prev');
      var nextBtn = wrapper.querySelector('.cl-tile__arrow--next');
      var swatchWrapper = wrapper.querySelector('.cl-tile__swatches');

      if (swatchWrapper && prevBtn && nextBtn) {
        function updateArrows() {
          prevBtn.style.visibility = swatchWrapper.scrollLeft <= 0 ? 'hidden' : 'visible';
          nextBtn.style.visibility = swatchWrapper.scrollLeft + swatchWrapper.clientWidth >= swatchWrapper.scrollWidth - 1 ? 'hidden' : 'visible';
        }
        nextBtn.addEventListener('click', function(e) { e.stopPropagation(); swatchWrapper.scrollLeft += 88; });
        prevBtn.addEventListener('click', function(e) { e.stopPropagation(); swatchWrapper.scrollLeft -= 88; });
        swatchWrapper.addEventListener('scroll', updateArrows);
        updateArrows();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTiles);
  } else {
    initTiles();
  }

  // Reinicializar tras filtros AJAX
  document.addEventListener('shopify:section:load', initTiles);

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('.cl-tile__swatch')) {
            initTiles();
          }
        });
      }
    });
  });

  var productGrid = document.querySelector('#results');
  if (productGrid) {
    observer.observe(productGrid, { childList: true, subtree: true });
  }

})();

